import React from 'react';

export const TermInfo = ({ term, onClose }) => {
  const { title, subtitle, description, terms } = term;

  return (
    <>
      <article className='contact-privacy__modal'>
        <header>
          <div className='ico logo-small'></div>
          <div className='ico close' onClick={onClose}></div>
        </header>
        <div className='title__box'>
          <h2>{title}</h2>
        </div>
        <div className='content__box'>
          <p>{description}</p>
          {terms &&
            terms.map((item) => {
              return (
                <div>
                  <h3>{item.main}</h3>
                  {item.childs &&
                    item.childs.map((child) => {
                      return (
                        <div>
                          {child.sub && <h4>{child.sub}</h4>}
                          {child.list &&
                            child.list.map((li) => {
                              return <p>{li}</p>;
                            })}
                          {child.table &&
                            child.table.map((tb) => {
                              return (
                                <table>
                                  <thead>
                                    <tr>
                                      <th colSpan={2}>{tb.title}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th>{tb.rows[0].key}</th>
                                      <th>{tb.rows[1].key}</th>
                                    </tr>
                                    <tr>
                                      <td className="content">{tb.rows[0].value}</td>
                                      <td className="content">{tb.rows[1].value}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              );
                            })}
                        </div>
                      );
                    })}
                </div>
              );
            })}
        </div>
      </article>
    </>
  );
};
